// Port of api/fuel/app/classes/insights/plays/heatmap.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'heatmap',
    insight: ['heatmap'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var plays = {}
        var total = 0

        var range = this.get_period_date_range(type, owner, filter)
        var heatmap = filter.heatmap || 'plays'
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        // Hardcode monday start (no session offline)
        var format = 'monday'

        if (heatmap === 'plays') {

            var sqlPlayers = players ? ' AND p.play_players = ' + players : ''

            var dates = Util.queryFast(
                'SELECT p.play_date, SUM(p.play_count) AS play_count' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlPlayers +
                ' GROUP BY p.play_date'
            )

            if (filter.period === 'all') {

                for (var di = 0; di < dates.length; di++) {
                    var item = dates[di]
                    var week = Util.weekofyear(item.play_date, format === 'sunday')
                    var stamp = Util.date('Y', item.play_date) + '/' + week

                    if (!plays[stamp]) plays[stamp] = { count: 0 }

                    plays[stamp].count += parseInt(item.play_count, 10)
                    total += parseInt(item.play_count, 10)
                }

            } else {

                for (var dj = 0; dj < dates.length; dj++) {
                    var item2 = dates[dj]

                    if (!plays[item2.play_date]) plays[item2.play_date] = { count: 0 }

                    plays[item2.play_date].count += parseInt(item2.play_count, 10)
                    total += parseInt(item2.play_count, 10)
                }

            }

        } else if (heatmap === 'weight') {

            var wDates = Util.queryFast(
                'SELECT p.play_date AS date,' +
                ' SUM(p.play_count) AS count,' +
                ' SUM(g.game_weight_avg * p.play_count) AS weight' +
                ' FROM play p JOIN game g ON p.game_id = g.game_id' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlCount +
                ' GROUP BY p.play_date'
            )

            if (filter.period === 'all') {

                for (var wi = 0; wi < wDates.length; wi++) {
                    var wItem = wDates[wi]
                    var wWeek = Util.weekofyear(wItem.date, format === 'sunday')
                    var wStamp = Util.date('Y', wItem.date) + '/' + wWeek

                    if (!plays[wStamp]) plays[wStamp] = { count: 0, totalWeight: 0, weight: 0 }

                    plays[wStamp].totalWeight += parseFloat(wItem.weight)
                    plays[wStamp].count += parseInt(wItem.count, 10)
                    plays[wStamp].weight = plays[wStamp].totalWeight / plays[wStamp].count
                    total += parseInt(wItem.count, 10)
                }

            } else {

                for (var wj = 0; wj < wDates.length; wj++) {
                    var wItem2 = wDates[wj]

                    if (!plays[wItem2.date]) plays[wItem2.date] = { count: 0, totalWeight: 0, weight: 0 }

                    plays[wItem2.date].totalWeight += parseFloat(wItem2.weight)
                    plays[wItem2.date].count += parseInt(wItem2.count, 10)
                    plays[wItem2.date].weight = plays[wItem2.date].totalWeight / plays[wItem2.date].count
                    total += parseInt(wItem2.count, 10)
                }

            }

        } else if (heatmap === 'wins' && type === Constants.TYPE_USER) {

            var winDates = Util.queryFast(
                'SELECT p.play_date AS date,' +
                ' SUM(p.play_count) AS count,' +
                ' SUM(p.play_won) AS wins' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlCount +
                ' GROUP BY p.play_date'
            )

            if (filter.period === 'all') {

                for (var xi = 0; xi < winDates.length; xi++) {
                    var xItem = winDates[xi]
                    var xWeek = Util.weekofyear(xItem.date, format === 'sunday')
                    var xStamp = Util.date('Y', xItem.date) + '/' + xWeek

                    if (!plays[xStamp]) plays[xStamp] = { count: 0, wins: 0 }

                    plays[xStamp].wins += parseInt(xItem.wins, 10)
                    plays[xStamp].count += parseInt(xItem.count, 10)
                }

            } else {

                for (var xj = 0; xj < winDates.length; xj++) {
                    var xItem2 = winDates[xj]

                    if (!plays[xItem2.date]) plays[xItem2.date] = { count: 0, wins: 0 }

                    plays[xItem2.date].wins += parseInt(xItem2.wins, 10)
                    plays[xItem2.date].count += parseInt(xItem2.count, 10)
                }

            }

            // Get total plays for wins mode
            var totalRows = Util.queryFast(
                'SELECT SUM(p.play_count) AS total' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                (players ? ' AND p.play_players = ' + players : '')
            )
            total = totalRows.length && totalRows[0].total ? parseInt(totalRows[0].total, 10) : 0

        } else if (heatmap === 'new' && type === Constants.TYPE_USER) {

            var earliestPlays = Util.queryFast(
                'SELECT p.game_id, MIN(p.play_date) AS play_date' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                (players ? ' AND p.play_players = ' + players : '') +
                ' GROUP BY p.game_id'
            )

            if (filter.period === 'all') {

                for (var ni = 0; ni < earliestPlays.length; ni++) {
                    var nItem = earliestPlays[ni]
                    var nWeek = Util.weekofyear(nItem.play_date, format === 'sunday')
                    var nStamp = Util.date('Y', nItem.play_date) + '/' + nWeek

                    if (!plays[nStamp]) plays[nStamp] = { count: 0 }

                    plays[nStamp].count++
                    total++
                }

            } else {

                // Get games played before the range
                var playsBefore = Util.queryFast(
                    'SELECT DISTINCT p.game_id' +
                    ' FROM play p' +
                    ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                    ' AND p.play_date < ' + range.start +
                    (players ? ' AND p.play_players = ' + players : '') +
                    ' GROUP BY p.game_id'
                )

                var beforeIndex = []
                for (var bi = 0; bi < playsBefore.length; bi++) {
                    beforeIndex.push(playsBefore[bi].game_id)
                }

                for (var nj = 0; nj < earliestPlays.length; nj++) {
                    var nItem2 = earliestPlays[nj]

                    if (beforeIndex.indexOf(nItem2.game_id) === -1) {
                        if (!plays[nItem2.play_date]) plays[nItem2.play_date] = { count: 0 }

                        plays[nItem2.play_date].count++
                        total++
                    }
                }

            }

        }

        // Handle negative start range
        if (range.start < 0) {
            var dateKeys = Object.keys(plays)
            for (var ki = 0; ki < dateKeys.length; ki++) {
                var parts = dateKeys[ki].split('/')
                var time = new Date(parseInt(parts[0], 10), 0, 1).getTime() / 1000

                if (range.start < 0 || time < range.start) {
                    range.start = time
                }
            }
        }

        return {
            start: range.start,
            end: range.end,
            plays: plays,
            totalPlays: total
        }

    }
})
